package org.hs_soft.runmynesto.di

import org.hs_soft.runmynesto.pages.home.mvi.HomeViewModel
import org.hs_soft.runmynesto.pages.home.sub_page.customer_card.mvi.CustomerCardViewModel
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.mvi.ClosingReportsViewModel
import org.hs_soft.runmynesto.pages.home.sub_page.dashboard.mvi.DashboardViewModel
import org.hs_soft.runmynesto.pages.home.sub_page.media_center.mvi.MediaCenterViewModel
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsViewModel
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductViewModel
import org.hs_soft.runmynesto.pages.home.sub_page.statistic.mvi.StatisticViewModel
import org.hs_soft.runmynesto.pages.home.sub_page.template.mvi.TemplateViewModel
import org.hs_soft.runmynesto.pages.home.sub_page.user.mvi.UserViewModel
import org.hs_soft.runmynesto.pages.login.mvi.LoginViewModel
import org.koin.dsl.module

val viewModelModule = module {

    factory {
        LoginViewModel(
            signInUseCase = get(),
            isLoggedInUseCase = get(),
            sendCodeForRestPassUseCase = get(),
            resetPasswordUseCase = get(),
        )
    }

    factory {
        HomeViewModel(
            tokenProvider = get(),
            fetchIdTokenUseCase = get(),
            saveCheckOutUseCase = get(),
            checkOutDataUseCase = get(),
            signOutUseCase = get(),
            userProfileDataUseCase = get(),
            hsSoftAppsUseCase = get(),
            shopListUseCase = get(),
            saveCompanyProfileIdUseCase = get(),
            optionsDataUseCase = get(),
            deleteCacheUseCase = get(),
            saveLanguageUseCase = get(),
            setNewCustomerUseCase = get(),
            getVirtualCardInfoUseCase = get(),
            getDataAssistantAnswerUseCase = get(),
            getDataAssistantMessageHistoryUseCase = get(),
            requestManager = get(),
            saveDataAssistantFavoriteMessagesUseCase = get(),
            globalSearchUseCase = get(),
        )
    }

    factory { (  refreshToken: () -> Unit) ->
        ProductViewModel(
            requestManager = get(),
            getDishPictureUseCase = get(),
            checkedIngredientsUseCase = get(),
            updateAllergenUseCase = get(),
            updateProductCheckoutUseCase = get(),
            updateProductPropertiesUseCase = get(),
            ingredientListUseCase = get(),
            updateProductCashBidImageUseCase = get(),
            updateProductUseCase = get(),
            productSaleGroupUseCase = get(),
            singleProductUseCase = get(),
            kitchenInfoUseCase = get(),
            productRestaurantUseCase = get(),
            printerLocationNamesUseCase = get(),
            updateProductRestaurantUseCase = get(),
            addProductUseCase = get(),
            productCategoriesUseCase = get(),
            imgUrlUseCase = get(),
            updateProductPriceUseCase = get(),
            getCompanyProfileIdUseCase = get(),
            addProductCategoryToDBUseCase = get(),
            getCachedProductCategoriesUseCase = get(),
            saveCachedProductCategoriesUseCase = get(),
            createProductAdditionUseCase = get(),
            updateProductAdditionUseCase = get(),
            getSavedCheckOutUseCase = get(),
            getTemplateCategoriesUseCase = get(),
            loadAppConstantsUseCase = get(),
            createProductIngredientUseCase = get(),
            deleteProductAdditionUseCase = get(),
            priceLevelsUseCase = get(),
            getSpecialPriceUseCase = get(),
            updateSpecialPriceUseCase = get(),
            createSpecialPriceUseCase = get(),
            updateProductSetUseCase = get(),
            getProductSetUseCase = get(),
            updateProductSetsListUseCase = get(),
        )
    }

    factory { ( refreshToken: () -> Unit) ->
        TemplateViewModel(
            requestManager = get(),
            getTemplateCategoriesUseCase = get(),
            getSingleTemplateCategoryUseCase =get(),
            addCategoryUseCase = get(),
            updateProductsPositionsUseCase = get(),
            updateTemplateCategoryUseCase = get(),
            updateTemplateCategoryImgUseCase = get(),
            updateSurchargeUseCase=get(),
            priceLevelsUseCase = get(),
            updatePriceLevelUseCase = get(),
            updateTemplateCheckoutUseCase = get(),
            getDishPictureUseCase = get(),
            updateProductUseCase = get(),
            productCategoriesUseCase = get(),
            getSavedCheckOutUseCase = get(),
            updateListOfCategoriesPositionsRepository = get(),
            getCompanyProfileIdUseCase = get(),
            setGridProductUseCase = get(),
            imgUrlUseCase = get(),

        )
    }

    factory { (  refreshToken: () -> Unit) ->
        UserViewModel(
            requestManager = get(),
            updateUserCheckoutUseCase = get(),
            updateUserPermissionUseCase = get(),
            addUserUseCase = get(),
            singleUserUseCase = get(),
            usersDataUseCase = get(),
            updateUserWaiterUseCase = get(),
            updateUserImageUseCase = get(),
            updateUserDataUseCase = get(),
            getSavedCheckOutUseCase = get(),
        )
    }
    factory { (refreshToken: () -> Unit) ->
        ClosingReportsViewModel(
            requestManager = get(),
            getSavedCheckOutUseCase = get(),
            closingReportsUseCase = get(),
            closingReportDetailUseCase = get(),
            getCompanyProfileIdUseCase = get(),
            printClosingReportsUseCase = get(),
            closeDailyReportUseCase = get(),
        )
    }

    factory { (refreshToken: () -> Unit) ->
        CustomerCardViewModel(
            requestManager = get(),
            loyaltyCardsUseCase = get(),
            loyaltyCardDetailUseCase = get(),
            creditClientUseCase = get(),
            updateLoyaltyCardUseCase = get(),
            createCustomerCardUseCase = get(),
            updateRangeLoyaltyCardUseCase = get(),
            resetRangeLoyaltyCardUseCase = get(),
            createLoyaltyCardUseCase = get(),
            filteredTransactionLoyaltyCardUseCase = get()
        )
    }
    factory {(refreshToken:()->Unit)->
        StatisticViewModel(
            requestManager = get(),
            initSearchBillUseCase = get(),
            getSavedCheckOutUseCase = get(),
            billSearchStatisticDataUseCase = get(),
            abcStatisticDataUseCase = get(),
            initABCStatisticUseCase = get(),
            billPdfUseCase = get(),

        )
    }

    factory { (  refreshToken: () -> Unit) ->
        OptionsViewModel(
            requestManager = get(),
            updatePrinterLocationUseCase = get(),
            optionsDataUseCase = get(),
            addNewSaleGroupUseCase = get(),
            singleSaleGroupUseCase = get(),
            updateSaleGroupUseCase = get(),
            salesGroupUseCase = get(),
            printerLocationNamesUseCase = get(),
            updateOptionUseCase = get(),
            saveCompanyProfileIdUseCase = get(),
            updateVirtualCardInfoUseCase = get(),
            appConfigUseCase = get(),
            updateAppConfigUseCase = get(),
            getCashRegisterConfigUseCase = get(),
            updateCashRegisterConfigUseCase = get(),
            getVirtualCardInfoUseCase = get(),
            priceLevelsUseCase = get(),
            getSavedCheckOutUseCase = get(),
            getMenuCardUseCase = get(),
            restaurantProjectsUseCase = get(),
            createFurnitureUseCase = get(),
            updateFurnitureUseCase = get(),
            createFloorUseCase = get(),
            updateFloorUseCase = get(),
            deleteFloorUseCase = get(),
            deleteRoomUseCase = get(),
            upsertProductsUseCase = get(),
            addCategoryUseCase = get(),
            updateProductPropertiesUseCase = get(),
            updateRoomUseCase = get(),
            createRoomUseCase = get(),
            updateRestaurantProjectUseCase = get(),
            deleteFurnitureUseCase = get(),
            createNewDepartmentUseCase = get(),
            checkOutDataUseCase = get(),
            saveCheckOutUseCase = get(),
            createNewRegionUseCase = get(),
            createNewShopUseCase = get(),
            createCashRegisterUseCase = get(),
            setNewCustomerUseCase = get(),
            addProductUseCase = get(),
            apaleoPropertiesUseCase = get(),
            apaleoPaymentMethodUseCase = get(),
            optionCreditCardUseCase = get(),
            cashRegisterGlobalUseCase = get(),
            updateCashRegisterGlobalUseCase = get(),
            apaleoSubAccountsUseCase = get(),
            tseLocationsUseCase = get(),
            loadAppConstantUseCase = get(),
            ingredientListUseCase = get(),
            aydenStoresUseCase = get(),
            listDeviceUseCase = get(),
            getTemplateCategoriesUseCase = get(),
            updatePriceCategoriesUseCase=get(),
        )
    }

    factory {(refreshToken:()->Unit) ->
        DashboardViewModel(
            requestManager = get(),
            shopStaticsUseCase = get(),
            dashboardConfigUseCase = get(),
            getCompanyProfileIdUseCase = get(),
            customerFrequencyUseCase = get(),
        )
    }


    factory {(refreshToken:()->Unit)->
        MediaCenterViewModel(
            requestManager = get(),
            getSavedCheckOutUseCase = get(),
            mediaListUseCase = get(),
            mediaDetailUseCase = get(),
            addNewMediaUseCase=get(),
            mediaTagsUseCase = get(),
            updateMediaUseCase = get(),
            imgUrlUseCase = get(),
            updateBase64ImgUseCase = get(),
            getSavedShopListUseCase = get(),
            loadAppConstantsUseCase = get(),
            addTagUseCase = get(),
            deleteTagUseCase = get(),
            getCachedProductCategoriesUseCase = get(),
            saveCachedProductCategoriesUseCase = get(),
            productCategoriesUseCase = get(),
        )
    }


}

